import { useState, useEffect } from "react";
import { db } from "../../firebase_config";
import { doc, onSnapshot } from "firebase/firestore";

export const useSiteWideSale = () => {
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [saleData, setSaleData] = useState({
    site_wide_sale_enabled: false,
    site_wide_sale_percent: 0,
    site_wide_sale_until: null,
  });

  useEffect(() => {
    setError(null);
    setIsPending(true);

    const docRef = doc(db, "enrollment_desc", "products");
    const unsub = onSnapshot(
      docRef,
      (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          setSaleData({
            site_wide_sale_enabled: data.site_wide_sale_enabled || false,
            site_wide_sale_percent: data.site_wide_sale_percent || 0,
            site_wide_sale_until: data.site_wide_sale_until?.toDate() || null,
          });
          setError(null);
          setIsPending(false);
        } else {
          setError("Sale configuration not found");
          setIsPending(false);
        }
      },
      (error) => {
        setError(error.message);
        setIsPending(false);
      }
    );
    return () => unsub();
  }, []);

  return { saleData, error, isPending };
};
